import { Link } from '@mnd-frontend/ui/publish/components';
import { PURPLE_700 } from '@mnd-frontend/ui/shared/tokens';
import styled from 'styled-components';

export const BlueLink = styled(Link)`
  color: ${PURPLE_700};

  &:hover,
  &:focus {
    color: ${PURPLE_700};
  }
`;
